import * as Styles from "@universityofmaryland/web-styles-library";
import { fetchGraphQL } from "@universityofmaryland/web-utilities-library/network";
import { slider } from "@universityofmaryland/web-elements-library/composite";
import { events, textLockup } from "@universityofmaryland/web-elements-library/atomic";
const createSliderWidget = ({
  token,
  query,
  url,
  categories,
  isThemeDark,
  headline,
  actions
}) => {
  const dataSlider = document.createElement("div");
  const slider$1 = slider.events({
    isThemeDark,
    dataSlider,
    headline,
    actions
  });
  let variables = { startDate: (/* @__PURE__ */ new Date()).toDateString() };
  let shadowRoot = null;
  const setShadowStyles = async ({
    shadowRoot: shadowRoot2,
    styles
  }) => {
    const styleElement = document.createElement("style");
    const optimizedCss = await Styles.utilities.transform.css.removeDuplicates(
      styles
    );
    styleElement.textContent = optimizedCss;
    shadowRoot2.appendChild(styleElement);
  };
  const callback = (shadow) => {
    shadowRoot = shadow;
  };
  const loadEvents = async () => {
    if (categories) {
      const related = categories.split(",");
      variables.related = related;
    }
    const fetchVariables = {
      query,
      url,
      token,
      variables
    };
    const feedData = await fetchGraphQL(fetchVariables);
    const slides = feedData?.data?.entries?.events.map(
      (data, i) => {
        const headline2 = document.createElement("p");
        headline2.textContent = data.title;
        const dateSign = events.sign({
          startMonth: data.startMonth,
          startDay: data.startDay,
          endDay: data.endDay,
          endMonth: data.endMonth,
          isThemeDark
        });
        const textLockup$1 = textLockup.date({
          headline: headline2,
          isThemeDark,
          dateSign
        });
        slider$1.styles += textLockup$1.styles;
        slider$1.styles += dateSign.styles;
        return textLockup$1;
      }
    );
    slides?.forEach((slide) => dataSlider.appendChild(slide.element));
    if (shadowRoot) setShadowStyles({ shadowRoot, styles: slider$1.styles });
    setTimeout(() => {
      slider$1.events.load();
    }, 100);
  };
  loadEvents();
  return {
    ...slider$1,
    events: {
      callback
    }
  };
};
export {
  createSliderWidget
};
//# sourceMappingURL=slider.js.map
